import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { FaTimes } from 'react-icons/fa';
import axios from 'axios';

const ReceiptReport = ({ onClose }) => {
  const { emailId, isLoggedIn } = useContext(UserContext);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('UrVote');

  useEffect(() => {
    if (!isLoggedIn || !emailId) return;

    const fetchReports = async () => {
      try {
        const response = await axios.get(`http://localhost:5000/receipt-report?emailId=${emailId}&type=${activeTab}`);
        setReports(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching receipt reports:', err);
        setError('Failed to fetch receipt data');
        setLoading(false);
      }
    };

    fetchReports();
  }, [emailId, isLoggedIn, activeTab]);

  // Group reports by month
  const groupedReports = reports.reduce((acc, report) => {
    const date = new Date(report.date);
    const monthYear = date.toLocaleString('default', { month: 'long', year: 'numeric' });
    
    if (!acc[monthYear]) {
      acc[monthYear] = [];
    }
    acc[monthYear].push(report);
    return acc;
  }, {});

  const renderTableHeaders = () => {
    if (activeTab === 'UrVote') {
      return (
        <tr>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>User Name</th>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>User Email</th>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>Donation Amount</th>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>Receipt Number</th>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>Date</th>
        </tr>
      );
    } else {
      return (
        <tr>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>User Name</th>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>User Email</th>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>{activeTab === 'Local Project' ? 'Project Name' : 'Charity Name'}</th>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>Donation Amount</th>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>Receipt Number</th>
          <th style={{
            padding: '12px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6'
          }}>Date</th>
        </tr>
      );
    }
  };

  const renderTableRow = (report, index) => {
    if (activeTab === 'UrVote') {
      return (
        <tr key={index}>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>{report.userName}</td>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>{report.userEmail}</td>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>${report.amount}</td>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>{report.receiptNumber}</td>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>{new Date(report.date).toLocaleDateString()}</td>
        </tr>
      );
    } else {
      return (
        <tr key={index}>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>{report.userName}</td>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>{report.userEmail}</td>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>{activeTab === 'Local Project' ? report.projectName : report.charityName}</td>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>${report.amount}</td>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>{report.receiptNumber}</td>
          <td style={{
            padding: '12px',
            border: '1px solid #dee2e6'
          }}>{new Date(report.date).toLocaleDateString()}</td>
        </tr>
      );
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      width: '60%',
      maxHeight: '80vh',
      overflowY: 'auto',
      zIndex: 1000
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <h2 style={{ margin: 0 }}>Receipt Report</h2>
        <FaTimes
          onClick={onClose}
          style={{
            cursor: 'pointer',
            fontSize: '20px'
          }}
        />
      </div>

      {/* Tabs */}
      <div style={{
        display: 'flex',
        gap: '10px',
        marginBottom: '20px',
        borderBottom: '1px solid #dee2e6'
      }}>
        {['UrVote', 'Local Project', 'Charities'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              padding: '10px 20px',
              border: 'none',
              background: 'none',
              borderBottom: activeTab === tab ? '2px solid #007bff' : 'none',
              color: activeTab === tab ? '#007bff' : '#000',
              cursor: 'pointer',
              fontWeight: activeTab === tab ? 'bold' : 'normal'
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div style={{ color: 'red' }}>{error}</div>
      ) : (
        <div>
          {Object.entries(groupedReports).map(([monthYear, monthReports]) => (
            <div key={monthYear} style={{ marginBottom: '30px' }}>
              <h3 style={{ 
                marginBottom: '15px',
                padding: '10px',
                backgroundColor: '#f8f9fa',
                borderRadius: '5px'
              }}>
                {monthYear}
              </h3>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginTop: '10px'
              }}>
                <thead>
                  {renderTableHeaders()}
                </thead>
                <tbody>
                  {monthReports.map((report, index) => renderTableRow(report, index))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReceiptReport;
